import { makeStyles } from "@material-ui/core";

import React from "react";

let responsiveLength = "1000";

let useSyles = makeStyles((theme) => ({
  root: {
    ...theme.grid.gridMdContent,
    // maxWidth: '100%',
    margin: "auto",
    marginTop: 100,
    marginBottom: 100,

    minHeight: 350,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#F8F7FB",
    borderRadius: 13,
    [theme.breakpoints.down("1500")]: {
      width: "90%",
    },
    [theme.breakpoints.down("1135")]: {
      padding: "30px 0",
    },

    [theme.breakpoints.down(1120)]: {
      minHeight: 525,
    },
    [theme.breakpoints.down("501")]: {
      width: "90%",
    },
  },
  grid: {
    width: "100%",
    margin: "auto",
    position: "relative",
    // color: '#ffffff',
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row-reverse",
    [theme.breakpoints.down("1135")]: {
      flexDirection: "column-reverse",
    },
    [theme.breakpoints.down(responsiveLength)]: {
      flexDirection: "column-reverse",
    },
  },
  gridImages: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    "& > img": {
      maxWidth: "100%",
      marginBottom: 10,
    },
    [theme.breakpoints.down(responsiveLength)]: {
      width: "100%",
      justifyContent: "center",
      "& > img": {
        maxWidth: "100%",
        marginBottom: 10,
      },
    },
  },
  desce: {
    margin: "20px 0px",
    width: 500,

    fontSize: 16,
    color: "#000000",
    [theme.breakpoints.down("1500")]: {
      fontSize: 16,
    },
    [theme.breakpoints.down("1250")]: {
      fontSize: 14,
    },
    [theme.breakpoints.down("700")]: {
      maxWidth: "70%",
      margin: "20px auto",
    },
    [theme.breakpoints.down("500")]: {
      width: "90%",
      margin: "auto",
      margin: "20px auto",
    },
  },
  title: {
    fontSize: 30,
    whiteSpace: "nowrap",
    fontWeight: 700,
    [theme.breakpoints.down("1500")]: {
      fontSize: 26,
    },
    [theme.breakpoints.down("500")]: {
      whiteSpace: "normal",
      width: "90%",
      margin: "auto",
      textAlign: "center",
    },
  },

  line: {
    borderRadius: 3,
    height: 4,
    border: "none",
    backgroundColor: theme.palette.light.type2,
    position: "absolute",
    top: -10,
    width: 30,
    [theme.breakpoints.down("1135")]: {
      top: -10,
      display: "none",
    },
    [theme.breakpoints.down(responsiveLength)]: {
      top: -10,
      display: "none",
    },
  },
  gridIconRight: {
    width: 50,
    marginRight: 40,
    [theme.breakpoints.down(responsiveLength)]: {
      marginRight: 0,
      display: "none",
    },
  },
  gridIconLeft: {
    width: 50,
    marginLeft: 0,
    transform: "rotate(180deg)",
    [theme.breakpoints.down(responsiveLength)]: {
      marginLeft: 0,
      display: "none",
    },
  },
  icon: {
    width: 50,
  },
  gridContent: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
    width: "50%",
    [theme.breakpoints.down(responsiveLength)]: {
      marginRight: 0,
      marginTop: 20,
      textAlign: "center",
      width: "100%",
      justifyContent: "center",
    },
  },
  bgBtn: {
    height: 40,
    width: 40,
    padding: 5,
    backgroundColor: "#132b41",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 9,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)",
    },
  },
  gridIcons: {
    width: 13,
    height: 13,
    padding: 10,
    borderRadius: "50%",
    backgroundColor: "#49A629",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cardList: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 20,
    marginBottom: 15,
  },
  titleIcons: {
    marginBottom: 0,
    marginLeft: 10,
    fontWeight: "bold",
    fontSize: 16,
  },
  gridCardList: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  iconArrowLeft: {
    marginLeft: 10,
  },

  gridBtn: {
    display: "flex",
    justifyContent: "flax-start",
    alignItems: "center",
    flexWrap: "wrap",
    margin: "45px auto 0px auto",
    [theme.breakpoints.down("1000")]: {
      justifyContent: "center",
    },
    [theme.breakpoints.down("500")]: {
      width: "90%",
      margim: "auto",
    },
    "& > a": {
      [theme.breakpoints.down("500")]: {
        width: "100%",
        marginBottom: 10,
      },
    },
  },
  btnWhite: {
    padding: "0px 33.5px",
    fontSize: 16,
    marginLeft: 5,
    [theme.breakpoints.down("500")]: {
      width: "100%",
      marginLeft: "0px",
    },
  },
  btnRed: {
    fontSize: 16,
    padding: "0px 22.3px",
    [theme.breakpoints.down("500")]: {
      width: "100%",
      margin: 0,
    },
  },
  gridlinkBtns: {},
}));

export default function Index({ data }) {
  let classes = useSyles();

  return (
    <div className={classes["root"]}>
      <div className={classes["grid"]}>
        <div
          style={{ position: "relative" }}
          className={classes["gridContent"]}
        >
          <div>
            <div className={classes["line"]} />
            <h3 className={classes["title"]}>
              معاملات آنلاین در کارگزاری پویان
            </h3>
            <p className={classes["desce"]}>
              اگر به دنبال فعالیت در بازار سرمایه، خرید و فروش سهام هستید،
              کارگزاری پویان به شما کمک می‌کند در مسیر رسیدن به اهداف مالی خود
              گام بردارید. این کارگزاری با ارائه سامانه‌های معاملاتی متنوع و
              حرفه‌ای، لذت تجربه‌ای جذاب و کارآمد را برای شما به ارمغان می‌آورد.
            </p>

            <div className={classes["gridBtn"]}>
              <a
                href="https://reg.pouyanbroker.ir/"
                target={"_blank"}
                className={classes["gridlinkBtns"]}
              >
                <button type="" className={`${classes["btnRed"]} btnPouyanRed`}>
                  دریافت کد بورسی
                </button>
              </a>
              <a href="tel:02191005777">
                <button
                  type="text"
                  className={`${classes["btnWhite"]} btnPouyanWhite`}
                >
                  تماس و مشاوره
                </button>
              </a>
            </div>
          </div>
        </div>
        <div className={classes["gridImages"]}>
          <img src={"/assets/images/stock.PNG"} alt={data?.title} />
        </div>
      </div>
    </div>
  );
}
